/**
 * Local mirror of reference-wells selection snapshot (ids only).
 * Do not import types from @repo/reference-wells — DIP / package isolation.
 */

export type TTrajectorySelectedReferenceTrajectory = {
  trajectoryId: number;
};

export type TTrajectorySelectedReferenceWellbore = {
  wellboreId: number;
  trajectories: TTrajectorySelectedReferenceTrajectory[];
};

export type TTrajectorySelectedReferenceDesign = {
  designId: number;
  wellbores: TTrajectorySelectedReferenceWellbore[];
};

export type TTrajectorySelectedReferenceWell = {
  wellId: number;
  fact?: TTrajectorySelectedReferenceWellbore[];
  plan?: TTrajectorySelectedReferenceDesign[];
};

export type TTrajectorySelectedReferenceTree = {
  wells: TTrajectorySelectedReferenceWell[];
};

export const EMPTY_TRAJECTORY_SELECTED_REFERENCE_TREE: TTrajectorySelectedReferenceTree = { wells: [] };

export function copyTrajectorySelectedReferenceTree(
  tree: TTrajectorySelectedReferenceTree,
): TTrajectorySelectedReferenceTree {
  return structuredClone(tree);
}
